import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class CoreVersion extends ApplicationRecord {
  static jsonapiType = "core_versions";

  @Attr({ persist: false }) createdAt: string;

  @Attr() event: string;

  @Attr() itemId: number;

  @Attr() itemSubtype: string;

  @Attr() itemType: string;

  @Attr() object: Record<string, any>;

  @Attr() objectChanges: Record<string, any>;

  @BelongsTo() user: User;
}

export default CoreVersion;
